import React, { useEffect, useState } from 'react';
import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
} from 'react-router-dom';

import { Paths } from './shared/paths';
import { AiAssistant } from './components/ai-assistant';
import Signin from './pages/signin/SignIn';
import Home from './pages/home/Home';
import SuperAdminDashboard from './pages/super-admin-dashboard/SuperAdminDashboard';
import ModeratorDashboard from './pages/moderator-dashboard/ModeratorDashboard';
import AdminDashboard from './pages/admin-dashboard/AdminDashboard';
import Settings from './pages/settings/Settings';
import User from './pages/user/User';
import UserCommunities from './pages/user/userCommunities/UserCommunities';
import UserSubscribers from './pages/user/userSubscribers/UserSubscribers';
import UserSubscriptions from './pages/user/userSubscriptions/UserSubscriptions';
import NotFoundPage from './components/reusable/error-pages/NotFoundPage/NotFoundPage';
import { LoginUserStatus, useAuth } from './context/AuthContext';
import Loader from './components/layout/loader/Loader';
import People from './pages/people/People';
import ForgotPassword from './pages/forgot-password/ForgotPassword';
import ResetPassword from './pages/reset-password/ResetPassword';
import ServerErrorPage from './components/reusable/error-pages/ServerErrorPage/ServerErrorPage';
import UnauthorizedPage from './components/reusable/error-pages/UnauthorizedPage/UnauthorizedPage';
import MaintenanceErrorPage from './components/reusable/error-pages/MaintenanceErrorPage/MaintenanceErrorPage';

interface IRouterProps {
  history: any;
}

const AppRouter = (props: IRouterProps) => {
  const { history } = props;
  const { loginUserStatus } = useAuth();

  if (loginUserStatus === LoginUserStatus.loading) {
    return (
      <div>
        <Loader />
      </div>
    );
  }

  const authChecking = (element) => {
    if (loginUserStatus === LoginUserStatus.forbidden) {
      return <UnauthorizedPage />;
    }

    if (loginUserStatus === LoginUserStatus.error) {
      return <ServerErrorPage />;
    }

    if (loginUserStatus === LoginUserStatus.maintenance) {
      return <MaintenanceErrorPage />;
    }

    return loginUserStatus === LoginUserStatus.loggedIn ? (
      element
    ) : (
      <Navigate to={Paths.signIn} />
    );
  };

  return (
    <Router>
      <AiAssistant />
      <Routes>
        <Route path={Paths.signIn} element={<Signin />} />
        <Route path={Paths.forgotPassword} element={<ForgotPassword />} />
        <Route path={Paths.resetPassword} element={<ResetPassword />} />
        <Route
          path={`${Paths.people.root}/*`}
          element={authChecking(<People />)}
        />

        <Route
          path={`${Paths.users.root}/:userId`}
          element={authChecking(<User />)}
        />
        <Route
          path={`${Paths.users.root}/:userId${Paths.users.communities}`}
          element={authChecking(<UserCommunities />)}
        />
        <Route
          path={`${Paths.users.root}/:userId${Paths.users.subscribers}`}
          element={authChecking(<UserSubscribers />)}
        />
        <Route
          path={`${Paths.users.root}/:userId${Paths.users.subscriptions}`}
          element={authChecking(<UserSubscriptions />)}
        />

        {/*<Route path={Paths.chats} element={authChecking(<Chats />)} />*/}
        {/*<Route*/}
        {/*  path={`${Paths.chats}/:chatId`}*/}
        {/*  element={authChecking(<Chat />)}*/}
        {/*/>*/}
        <Route
          path={`${Paths.moderatorDashboard.root}/*`}
          element={authChecking(<ModeratorDashboard />)}
        />
        <Route
          path={`${Paths.adminDashboard.root}/*`}
          element={authChecking(<AdminDashboard />)}
        />
        <Route
          path={`${Paths.superAdminDashboard.root}/*`}
          element={authChecking(<SuperAdminDashboard />)}
        />
        <Route
          path={`${Paths.settings.root}/*`}
          element={authChecking(<Settings />)}
        />
        <Route path={Paths.root} element={authChecking(<Home />)} />
        {Paths.root !== '/' && (
          <Route
            path={'/'}
            element={
              <Navigate
                to={
                  loginUserStatus === LoginUserStatus.loggedIn
                    ? Paths.root
                    : Paths.signIn
                }
              />
            }
          />
        )}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </Router>
  );
};

export default AppRouter;
